<template>
    <span class="program">
        <span v-for="(item, index) in computedValue" :key="index" class="program__item">
            <span class="program__item__week">
                <span
                    v-for="(day, day_index) in (days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'])"
                    :key="day_index"
                    class="program__item__day"
                    :class="{
                        active: item.weekdays.indexOf(day) >= 0,
                        'active-next': item.weekdays.indexOf(days[day_index + 1]) >= 0,
                        'active-prev': item.weekdays.indexOf(days[day_index - 1]) >= 0,
                    }"
                    @click="!disabled && toggleDay(day, item)"
                    >{{ day }}</span
                >
            </span>

            <span class="program__item__add" @click="addSwitchPoint(item)" v-if="!disabled && !fromto">
                <span v-if="tarif">{{ $t('systems.parameters.program-tarif.add') }}</span>
                <span v-else-if="toggle">{{ $t('systems.parameters.program-toggle.add') }}</span>
                <span v-else>{{ $t('systems.parameters.program.add') }}</span>
            </span>

            <span v-if="!fromto" class="program__item__points" :style="{ height: item.switchPoints.length * 39 + 'px' }">
                <span v-for="(point, index) in item.switchPoints" :key="index" class="program__item__point" :class="{ hot: parseInt(point.value) >= 20 }" :style="{ top: index * 39 + 'px' }">
                    <input type="text" v-model="point.time" :disabled="disabled" v-time class="program__item__point__time" @blur="blurTimeInput(item)" />
                    <span v-if="!switcher && !tarif && !toggle">
                        <input type="text" v-model="point.value" :disabled="disabled" v-temperaturenumber="{ step: step, min: min, max: max }" class="program__item__point__temperature" />
                    </span>
                    <span v-if="tarif" class="program__item__tarif">
                        <select class="tarif" v-model="point.value">
                            <option value="0">{{ $t('general.tarif') }} 1</option>
                            <option value="1">{{ $t('general.tarif') }} 2</option>
                            <option value="2">{{ $t('general.tarif') }} 3</option>
                            <option value="3">{{ $t('general.tarif') }} 4</option>
                            <option value="4">{{ $t('general.tarif') }} 5</option>
                        </select>
                    </span>
                    <span v-if="toggle" class="program__item__toggle">
                        <!-- <input type="checkbox" @change="checkValue($event, index, point)" :checked="point.value" /> -->
                        <div class="toggle" :class="{ on: point.value === 1, off: point.value === 0 }" @click="checkValue($event, point)" :checked="point.value">
                            <div class="toggle__bg toggle__bg--off">&nbsp;</div>
                            <div class="toggle__bg toggle__bg--on">&nbsp;</div>
                        </div>
                    </span>
                    <span v-if="switcher" class="program__item__switch">
                        <!-- <custom-switch
                            id="enabled"
                            name="enabled"
                            ng-model="point.value"
                            class="switch--small"
                        ></custom-switch>-->
                        <!-- MAY NOT EVEN EXIST? -->
                        <span class="switch switch--small">
                            <small></small>
                            <input type="checkbox" id="enabled" name="enabled" v-model="point.value" />
                        </span>
                    </span>
                    <span
                        @click="dropSwitchPoint(item, index)"
                        v-if="!disabled"
                        class="program__item__point__drop"
                        :class="{
                            inactive: item.switchPoints.length <= 1,
                            'program__item__point__drop--to': fromto,
                        }"
                    >
                        <i class="icon icon--action-decline"></i>
                    </span>
                </span>
            </span>

            <span v-else class="program__item__points" :style="{ height: item.values.length * 39 + 'px' }">
                <span
                    v-for="(point, index) in item.values"
                    :key="index"
                    class="program__item__point"
                    :class="{ inactivetime: point.start === '00:00' && point.stop === '00:00' }"
                    :style="{ top: index * 39 + 'px' }"
                >
                    <input v-if="fromto" type="text" v-model="point.start" :disabled="disabled" v-time class="program__item__point__time" @blur="blurTimeInput(item)" />

                    <input v-if="fromto" type="text" v-model="point.stop" :disabled="disabled" v-time class="program__item__point__time program__item__point__time--to" @blur="blurTimeInput(item)" />
                </span>
            </span>
        </span>
    </span>
</template>

<script>
import orderBy from 'lodash/orderBy';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import temperaturenumber from '@/directives/temperaturenumber';
import time from '@/directives/time';

export default {
    directives: {
        temperaturenumber,
        time,
    },
    props: {
        value: Array,
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100000,
        },
        step: Number,
        switcher: {
            type: Boolean,
            default: false,
        },
        tarif: {
            type: Boolean,
            default: false,
        },
        toggle: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        fromto: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            computedValue: false,
            defaultValue: this.min.toFixed(1) + '°',
        };
    },
    watch: {
        computedValue: {
            handler: function(v) {
                if (v) {
                    this.$emit('onValueChange', v);
                }
            },
            deep: true,
        },
    },
    mounted() {
        let value = this.value;

        if (this.value.length === 0) {
            value = new Array({
                switchPoints: [],
                weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
            });
        }

        this.computedValue = cloneDeep(value);
        this.computedValue.forEach(item => {
            this.orderPoints(item);
        });
    },
    methods: {
        checkValue(e, item) {
            const elem = e.target.classList.contains('toggle') ? e.target : e.target.parentElement;
            if (elem.classList.contains('on')) {
                elem.classList.remove('on');
                elem.classList.add('off');
                item.value = 0;
            } else if (elem.classList.contains('off')) {
                elem.classList.add('on');
                elem.classList.remove('off');
                item.value = 1;
            }
        },
        blurTimeInput(item) {
            setTimeout(() => {
                this.orderPoints(item);
            }, 50);
        },
        orderPoints(item) {
            if (this.fromto) {
                item.values = orderBy(item.values, 'start');
                let helpData = [];
                item.values.forEach(v => {
                    if (v.start !== '00:00' || v.stop !== '00:00') helpData.push(v);
                });
                for (let i = helpData.length; i < 3; i++) {
                    helpData.push({
                        start: '00:00',
                        stop: '00:00',
                    });
                }
                item.values = helpData;

                console.log(item);
            } else {
                item.switchPoints = orderBy(item.switchPoints, 'time');
            }
        },
        toggleDay(day, item) {
            let index = item.weekdays.indexOf(day);

            if (index >= 0) {
                // do not remove the only weekday
                if (item.weekdays.length <= 1) return;

                // remove day
                pullAt(item.weekdays, index);

                // add new item with single day
                let newItem;

                if (this.fromto) {
                    newItem = {
                        values: [
                            {
                                start: '00:00',
                                stop: '00:00',
                            },
                            {
                                start: '00:00',
                                stop: '00:00',
                            },
                            {
                                start: '00:00',
                                stop: '00:00',
                            },
                        ],
                        weekdays: [day],
                    };
                } else {
                    newItem = {
                        switchPoints: JSON.parse(JSON.stringify(item.switchPoints)),
                        weekdays: [day],
                    };
                }

                this.computedValue.push(newItem);
            } else {
                // add day
                item.weekdays.push(day);
                item.weekdays.sort((a, b) => {
                    let days = {
                        Mo: 0,
                        Tu: 1,
                        We: 2,
                        Th: 3,
                        Fr: 4,
                        Sa: 5,
                        Su: 6,
                    };

                    if (days[a] > days[b]) {
                        return 1;
                    } else if (days[a] < days[b]) {
                        return -1;
                    } else {
                        return 0;
                    }
                });

                // remove day from other item
                forEach(this.computedValue, (currentItem, cindex) => {
                    if (currentItem && item != currentItem) {
                        let currentIndex = currentItem.weekdays.indexOf(day);
                        if (currentIndex >= 0) {
                            // if only day, remove item; else, just remove day from weekdays array
                            if (currentItem.weekdays.length <= 1) {
                                pullAt(this.computedValue, cindex);
                            } else {
                                pullAt(currentItem.weekdays, currentIndex);
                            }
                        }
                    }
                });
            }
        },
        addSwitchPoint(item) {
            if (item.switchPoints.length >= 6) return;

            if (this.tarif) {
                item.switchPoints.unshift({
                    time: '00:00',
                    value: 0,
                });
            } else {
                item.switchPoints.unshift({
                    time: '00:00',
                    value: this.defaultValue,
                });
            }
        },
        dropSwitchPoint(item, index) {
            pullAt(item.switchPoints, index);
            item.switchPoints.splice();
        },
    },
};
</script>

<style lang="scss">
.program {
    display: block;
    max-height: 400px;
    min-width: 260px;
    overflow: auto;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);

    &__item {
        display: block;

        &__week {
            display: block;
            padding: 10px;
            text-align: center;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
        }

        &__day {
            display: inline-block;
            width: 30px;
            height: 30px;
            padding: 2px;
            line-height: 22px;
            text-align: center;
            border: 2px solid transparent;

            // border-radius: 50%;
            font-weight: bold;
            font-size: 12px;
            color: #adadad;
            cursor: pointer;
            border-radius: 50%;
            transition: all 200ms;

            &.active {
                color: #555555;
                border: 2px solid #555555;
                padding: 2px 0;

                &.active-next {
                    border-right-width: 0;
                    padding-right: 2px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }

                &.active-prev {
                    border-left-width: 0;
                    padding-left: 2px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }
            }
        }

        &__add {
            display: block;
            padding: 5px 0;

            font-size: 12px;
            text-align: center;
            cursor: pointer;
        }

        &__points {
            display: block;
            position: relative;
        }

        &__point {
            display: block;
            padding: 8px 10px;
            text-align: right;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            background-color: white;

            @include clearfix;
            transition: background-color 300ms, top 300ms;

            &:nth-child(odd) {
                background-color: $color-gray-light;
            }

            &.hot {
                .program__item__point__time {
                    background-color: #e22f43;
                }

                .program__item__point__temperature {
                    color: #e22f43 !important;
                }
            }
            &.inactivetime {
                .program__item__point__time {
                    background-color: #aaa;
                }
            }

            &__time {
                float: left;
                width: 45px;
                margin-top: 3px;
                border: 0;

                background-color: #3f72d7;
                color: white !important;
                text-align: center;
                font-size: 12px;
                line-height: 20px;

                &:focus {
                    outline: none;
                }

                &--to {
                    float: right;
                }
            }

            &__temperature {
                border: 0;
                width: 60px;
                padding: 0;

                background: transparent;
                font-size: 18px;
                color: #3f72d7 !important;
                text-align: right;

                &:focus {
                    outline: none;
                }
            }

            &__drop {
                display: inline-block;
                cursor: pointer;

                @media (hover: hover) {
                    &:hover {
                        color: $color-accent;
                    }
                }

                &.inactive {
                    opacity: 0.5;
                    cursor: normal;
                    pointer-events: none;
                }
            }
        }

        &__switch {
            vertical-align: middle;
            display: inline-block;
            line-height: 1;
            margin-right: 5px;
        }
    }
}

.switch {
    &.checked {
        background: $brand-primary;
        border-color: $brand-primary;
    }

    &--small {
        border-radius: 20px;
        height: 20px;
        width: 33px;

        &.checked {
            small {
                left: 13px;
            }
        }

        small {
            height: 20px;
            width: 20px;
        }
    }
}
</style>
